import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function CheckMarkCircle({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={cn('text-white', className)}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.99996 18.9583C5.05829 18.9583 1.04163 14.9416 1.04163 9.99996C1.04163 5.05829 5.05829 1.04163 9.99996 1.04163C14.9416 1.04163 18.9583 5.05829 18.9583 9.99996C18.9583 14.9416 14.9416 18.9583 9.99996 18.9583ZM9.99996 2.29163C5.74996 2.29163 2.29163 5.74996 2.29163 9.99996C2.29163 14.25 5.74996 17.7083 9.99996 17.7083C14.25 17.7083 17.7083 14.25 17.7083 9.99996C17.7083 5.74996 14.25 2.29163 9.99996 2.29163Z'
                fill='currentColor'
            />
            <path
                d='M8.8167 12.9833C8.65003 12.9833 8.4917 12.9166 8.37503 12.8L6.0167 10.4416C5.77503 10.2 5.77503 9.79996 6.0167 9.55829C6.25837 9.31663 6.65837 9.31663 6.90003 9.55829L8.8167 11.475L13.1 7.19163C13.3417 6.94996 13.7417 6.94996 13.9834 7.19163C14.225 7.43329 14.225 7.83329 13.9834 8.07496L9.25837 12.8C9.1417 12.9166 8.98337 12.9833 8.8167 12.9833Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default CheckMarkCircle;

